export default __webpack_public_path__ + "locales/pt/JavascriptSdk.json?hash=255e250b55056a995f54d16e5c169673";